import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AgentSession } from '../../modules/b2b/api';

export interface AgentAuthState {
  session: AgentSession | null;
}

const initialState: AgentAuthState = {
  session: null,
};

export const name = 'agentAuth';

const agentAuthSlice = createSlice({
  name,
  initialState,
  reducers: {
    setAgentSession(state, { payload }: PayloadAction<AgentSession>) {
      state.session = payload;
    },
    clearAgentSession(state) {
      state.session = null;
    },
  },
});

export const { clearAgentSession, setAgentSession } = agentAuthSlice.actions;

export default agentAuthSlice.reducer;
